/**
 * Metabase public-share endpoints for the platform statistics dashboards.
 *
 * The UUID in each path is a Metabase "public link" — an unauthenticated
 * endpoint enabled per-question in the Metabase admin UI. Anyone with the URL
 * can fetch the aggregated JSON without a session, cookie, or token; the UUID
 * acts as the bearer secret. Rotating means disabling and re-enabling the
 * public link in Metabase, then editing the URL below.
 *
 * Manage public links here:
 * https://stats.zonhub.com/admin/settings/public-sharing
 *
 * Only safe for data that can be shown to logged-out users (no row-level auth,
 * no user scoping). Do not reuse this pattern for anything user-specific.
 *
 * To point the dashboards at a different Metabase host per environment, edit
 * this file rather than adding env vars — the URLs are treated as source
 * constants like the routes in ./routes.ts.
 */

/** Powers FinancialPerformanceGraph on /statistics/platform. */
export const METABASE_FINANCIAL_PERFORMANCE_URL =
	"https://stats.zonhub.com/public/question/4f373cc8-8871-4be5-94e1-b163d8e41cca.json"

/** Powers ExpectedVsActualGraph on /statistics/platform. */
export const METABASE_EXPECTED_VS_ACTUAL_URL =
	"https://stats.zonhub.com/public/question/e3c748fd-435e-442f-bbff-7c53404bf800.json"

/** Powers FundedAmountPieChart on /statistics/platform. */
export const METABASE_CROWDFUNDING_SUM_URL =
	"https://stats.zonhub.com/public/question/059cf721-21d5-4df1-b67d-010d27dc7352.json"

/**
 * Powers ProjectsOverviewTable on /statistics/platform. Rows are keyed by `nr`
 * (see ProjectsOverview.tsx METRIC_BY_NR). Metabase question 597 — adds
 * interest paid (nr 10) and capital + interest (nr 11) on top of question 595.
 */
export const METABASE_CROWDFUNDING_OVERVIEW_URL =
	"https://stats.zonhub.com/public/question/01160d13-1c24-484c-96f3-fc725734301a.json"

/**
 * Reference date shown in the "as per {date}" subtitle above each Metabase-
 * backed dashboard on /statistics/platform. Metabase questions run live, but
 * we still surface a single as-of date to the reader — bump this when the
 * dashboards should reflect a new reporting cutoff. Month is 0-indexed.
 */
export const endDateStatistics = new Date(2026, 6, 1)
